export const MAX_LENGTH = 1000;
